import {useCalendarStore} from '@components/calendar/calendar-store'
import {endOfDay, isAfter, isSameDay} from 'date-fns'
import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {
  getTaskHeight,
  proportionPixelsDivideOnHour,
  validDateFormat
} from '../../utils'
import {useDraggableStore} from '../draggable/draggable-store'

const TaskContentTw = tw.div`
  pl-8
  pr-2
  border
  border-solid
  rounded-4
  border-bg-main-old
  flex
  justify-between
  overflow-hidden
  right-0
  left-0
  bg-input-disabled-old
  absolute
  z-20
`

const TextTw = tw.div`
  flex
  mt-4
  leading-4
  text-11
  text-main-old
  opacity-60
`

interface Props {
  start: Date
  end: Date
  currentDate: Date
  currentHour: number
}

export const GreyContent = observer(
  // eslint-disable-next-line max-lines-per-function
  ({start, end, currentDate, currentHour}: Props) => {
    const [state] = useCalendarStore()
    const [draggableState] = useDraggableStore()

    if (state.openedAllDayPopup) {
      return null
    }

    if (draggableState.enabled && !state.openedPopup) {
      return null
    }

    const startDate = state.startDatePopup
      ? state.startDatePopup
      : state.endDatePopup
    const deadline = state.endDatePopup

    const isAllDay =
      !isSameDay(deadline, currentDate) && !isSameDay(startDate, currentDate)

    if (
      validDateFormat(startDate, 'yyyy-MM-dd HH') ===
      validDateFormat(start, 'yyyy-MM-dd HH')
    ) {
      const height = getTaskHeight(startDate, deadline)
      const minutes = startDate.getMinutes()
      const top = minutes * proportionPixelsDivideOnHour
      return (
        <TaskContentTw
          style={{
            top,
            height
          }}
        >
          <TextTw>
            {!state.addTaskWithStartDate ? (
              validDateFormat(state.endDatePopup, 'HH:mm')
            ) : (
              <>
                {validDateFormat(state.startDatePopup, 'HH:mm')}-
                {validDateFormat(state.endDatePopup, 'HH:mm')}
              </>
            )}
          </TextTw>
        </TaskContentTw>
      )
    } else if (
      isSameDay(deadline, start) &&
      !isSameDay(startDate, end) &&
      startDate < end &&
      deadline > start
    ) {
      if (
        !isAllDay &&
        currentHour === 0 &&
        isAfter(currentDate, endOfDay(startDate))
      ) {
        const height = getTaskHeight(startDate, deadline, {
          startFromZero: true
        })
        const top = 0
        return (
          <TaskContentTw
            style={{
              top,
              height
            }}
          >
            <TextTw>
              {validDateFormat(state.startDatePopup, 'HH:mm')}-
              {validDateFormat(state.endDatePopup, 'HH:mm')}
            </TextTw>
          </TaskContentTw>
        )
      }
    } else if (
      !isSameDay(deadline, start) &&
      !isSameDay(startDate, end) &&
      startDate < end &&
      deadline > start
    ) {
      if (isAllDay && currentHour === 0) {
        const height = getTaskHeight(startDate, deadline, {
          allDay: true,
          startFromZero: true
        })
        const top = 0
        return (
          <TaskContentTw
            style={{
              top,
              height
            }}
          >
            <TextTw>
              {validDateFormat(state.startDatePopup, 'HH:mm')}-
              {validDateFormat(state.endDatePopup, 'HH:mm')}
            </TextTw>
          </TaskContentTw>
        )
      }
    }

    return null
  }
)
